import  { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getAxiosInstance from '../api/axiosInstance';

const axiosInstance = getAxiosInstance();



const NewGuest = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        company_name: ''
    });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.first_name) {
            newErrors.first_name = 'First name is required';
        }
        if (!formData.last_name) {
            newErrors.last_name = 'Last name is required';
        }
        if (!formData.company_name) {
            newErrors.company_name = 'Company name is required';
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setError(null);

        try {
            const response = await axiosInstance.post('/guests', formData);
            if (response.status === 201 || response.status === 200) {
                const newGuest = response.data;

                // Navigate to CheckInOutPage with the new guest's data
                navigate('/checkin-out', {
                    state: {
                        userType: "guest",
                        selectedUser: {
                            id: newGuest.guest_id,
                            first_name: newGuest.first_name,
                            last_name: newGuest.last_name,
                            company_name: newGuest.company_name,
                            created_at: newGuest.created_at
                        }
                    }
                });
            }
        } catch (err) {
            setError(err);
        }
    };

    return (
        <>
            <form className='grid grid-cols-12 p-8 h-auto' onSubmit={handleSubmit}>
                <div className='col-span-12 p-4'>
                    <h1 className='text-4xl font-medium mb-4 font-primary not-italic text-orange'>
                        PLEASE ENTER GUEST DETAILS
                    </h1>
                </div>
                {/*<form className='w-full' onSubmit={handleSubmit}>*/}
                <div className='col-span-6 p-4 portrait-md:col-span-12 portrait-md:pb-0'>
                    <div className='mb-4 flex gap-4 items-center'>
                        <label
                            htmlFor='firstName'
                            className='block text-textDark font-medium uppercase' style={{ width: "100px" }}>
                            First Name
                        </label>
                        <input
                            type='text'
                            id="first_name"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            className='shadow appearance-none border rounded-4 flex-1 py-4 px-3 text-textDark leading-tight focus:outline-none focus:shadow-outline'
                            placeholder='Enter first name'
                            required
                        />
                    </div>
                    <div className='mb-4 flex gap-4 items-center'>
                        <label
                            htmlFor='lastName'
                            className='block text-textDark font-medium  uppercase' style={{ width: "100px" }}>
                            Last Name
                        </label>
                        <input
                            type='text'
                            id="last_name"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                            className='shadow appearance-none border rounded-4 flex-1  py-4 px-3 text-textDark leading-tight focus:outline-none focus:shadow-outline'
                            placeholder='Enter last name'
                            required
                        />
                    </div>
                </div>
                <div className='col-span-6 p-4 portrait-md:col-span-12 portrait-md:pt-0'>
                    <div className='mb-4 flex gap-4 items-center'>
                        <label
                            htmlFor='company'
                            className='block text-textDark font-medium uppercase' style={{ width: "100px" }}>
                            Company
                        </label>
                        <input
                            type='text'
                            id="company_name"
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            className='shadow appearance-none border rounded-4 flex-1 py-4 px-3 text-textDark leading-tight focus:outline-none focus:shadow-outline'
                            placeholder='Enter company'
                            required
                        />
                    </div>
                    {error && <div className="text-red-500 mb-4">Error: {error.message}</div>}
                    <div className='flex justify-end'>
                        <button
                            type='submit'
                            className='bg-accent hover:bg-darkgrey text-white uppercase font-primary font-light tracking-wide py-4 px-8 rounded-4'>
                            Save Details
                        </button>
                    </div>
                </div>
                {/*</form>*/}
            </form>
        </>
    );
};

export default NewGuest;